import EmailNotificationBaseService from 'services/notification/subServices/email/EmailNotificationBaseService';

import SubmissionRejectedEmailNotification from 'models/notification/email/SubmissionRejectedEmailNotification';

export default class SubmissionRejectedEmailNotificationService extends EmailNotificationBaseService {
	toModel(notification) {
		return new SubmissionRejectedEmailNotification(notification);
	}
}
